import axios from "axios";
import { ENUM_LCS_NAME, ENUM_TOAST_TYPE, TEST_MODE } from "../store/enums";
import { ENUM_COMMON_EVENT } from "../hooks/common/useListener";
import { dispatchCusEvent, messageByCode } from "../utils/utils";

export const API_URL = "/api";
export const PREFIX = TEST_MODE ? "https://dev777.cryptoslot.games/" : "";

axios.interceptors.response.use((response) => {
  if (response?.data?.message === "Unauthenticated.") {
    localStorage.removeItem(ENUM_LCS_NAME.userId);
    localStorage.clear();
    window.location.href = "/";
  }
  return response;
});

export const cusAxios = (props, skipCodeErrorList = []) =>
  new Promise((resolve, reject) => {
    axios(props)
      .then((response) => {
        const data = response.data || response;

        if (skipCodeErrorList.includes(data.dataError)) {
          reject(data);
          return;
        }

        // ошибка авторизации
        if (+data.errorCode === 1) {
          dispatchCusEvent(ENUM_COMMON_EVENT.sessionError);
          reject(response);
          return;
        }

        // указанный email не подтвержден
        if (+data.dataError === 524) {
          dispatchCusEvent(ENUM_COMMON_EVENT.emailNotConfirmed);
          reject(response);
          return;
        }

        const error = data.error || data.dataError;
        if (error) {
          const errorText =
            typeof data?.error === "string"
              ? data?.error
              : data?.error?.text || "An error occurred";
          const messageError = data.dataError ? messageByCode(data.dataError) : errorText;

          dispatchCusEvent(ENUM_COMMON_EVENT.translationToast, {
            message: messageError,
            type: ENUM_TOAST_TYPE.error
          });

          reject();
          return;
        }

        resolve(response);
      })
      .catch(reject);
  });

// export const thenMessageServer = (e) => {
//   const messages = messageByText();

//   const data = e.data;
//   if (!data) return errorToast(messages.unexpected);

//   if (data.status || data.ok) {
//     if (data.message) successToast(data.message);
//     return;
//   }

//   return errorToast(data.message || messages.unknown);
// };

// export const catchMessageServer = (e) => {
//   if (typeof e === "string") return errorToast(e);
//   const messages = messageByText();

//   if (!e.response?.data) return errorToast(messages.notRespond);
//   return errorToast(e.response?.data?.message || messages.unknown);
// };
